<template>
  <div class="containe">
    <div class="popup">
      <div class="popup_header flex mb_20">
        <div class="popup_search flex">
          <div class="w_220 mr_20">
            <el-input v-model="tableParams.name"
                      placeholder="名称"
                      @keyup.enter.native="getTableDataSearch()"></el-input>
          </div>
          <el-button @click="getTableDataSearch()"
                     type="primary">搜索</el-button>
          <el-button @click="resetTableData"
                     type="danger">重置</el-button>
        </div>
      </div>
      <div class="popup_main">
        <el-table :data="tableData"
                  border
                  style="width: 100%"
                  class="mb_20">
          <el-table-column prop="code"
                           label="单位编码"
                           width="180"  align="center"></el-table-column>
          <el-table-column prop="name"
                           label="单位名称"
                           width="180"  align="center"></el-table-column>
          <el-table-column label="操作"  align="center">
            <template slot-scope="r">
              <el-button @click="unitSelected(r.row)"
                         type="text">选定</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="update_page_wrap flex justify_end">
          <el-pagination @current-change="pageChange"
                         background
                         layout="total, prev, pager, next"
                         :total="tableTotal"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {

  data() {
    return {
      tableData: [],
      exit_dialog: false,
      tableParams: {
        pageNum: 1,
        pageSize: 10,
        name: '',
      },
      tableTotal: 0,
      productDetailDialog: false,
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    unitSelected(r) {
      this.$emit('unitSelected', r);
    },
    resetTableData() {
      this.tableParams = {
        pageNum: 1,
        pageSize: 10,
        name: '',
      };
      this.getTableData();
    },
    pageChange(i) {
      this.tableParams.pageNum = i;
      this.getTableData();
    },
    getTableDataSearch(){
      this.tableParams.pageNum = 1;
      this.getTableData();
    },
    getTableData() {
      this.$axios
        .get("/user/infoUnits/getPage", {
          params: this.tableParams,
        })
        .then(res => {
          if (res.status == 200) {
            this.tableData = res.data.page.list;
            this.tableTotal = res.data.page.total;
          }
        });
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/theUnit.vue